export default __webpack_public_path__ + "static/media/check_icon.0d1d9d2c.webp";